import { FC } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Stack, Typography } from "@mui/material";
import editPencil from "../../assets/icons/edit-pencil.svg";
import trashEmpty from "../../assets/icons/trash-empty.svg";
import EventDetailsModalStyle from "./EventDetailsModalStyle";
import ButtonComponent from "../../components/button/ButtonComponent";
import { useTranslation } from "react-i18next";
interface EventDetailModelProps {
  handleClose: () => void;
  setDeleteCalenderOpen: () => void;
  eventData: any;
}

const EventDetailsModal: FC<EventDetailModelProps> = ({
  handleClose,
  setDeleteCalenderOpen,
  eventData,
}) => {
  const { t } = useTranslation()
  const navigateTo = useNavigate();
  const startEvent = new Date(eventData?.start);
  const endEvent = new Date(eventData?.end);

  const deleteSelectedEvent = () => {
    setDeleteCalenderOpen();
  };

  const handelEditEvent = (id: string) => {
    handleClose();
    navigateTo(`/add-event?editId=${id}`);
  };

  return (
    <>
      <Box>
        <Grid container>
          <Grid item xs={6} sm={8} lg={8} md={8}>
            <Typography {...EventDetailsModalStyle.mainHeaderTypo}>
              {eventData?.title}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={4} lg={4} md={4}>
            <Box sx={{ ...EventDetailsModalStyle.headerActionsBox }}>
              <img
                onClick={() => handelEditEvent(eventData?.id)}
                style={EventDetailsModalStyle.imgStyle}
                src={editPencil}
                alt="communityImg"
              />
              <img
                onClick={() => deleteSelectedEvent()}
                style={EventDetailsModalStyle.imgStyle}
                src={trashEmpty}
                alt="communityImg"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} lg={12} md={12} mt={4}>
            <Typography {...EventDetailsModalStyle.mainTitleTypo}>
              {t("calendarModal.addedBy")}
            </Typography>
            <Typography {...EventDetailsModalStyle.subTitleTypo} mt={1}>
              {eventData?.name}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} lg={12} md={12} mt={2}>
            <Typography {...EventDetailsModalStyle.mainTitleTypo}>
              {t("calendarModal.venue")}
            </Typography>
            <Typography {...EventDetailsModalStyle.subTitleTypo} mt={1}>
              {eventData?.venue}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12} md={12} mt={2}>
            <Typography {...EventDetailsModalStyle.mainTitleTypo}>
              {t("calendarModal.start")}
            </Typography>
            <Typography {...EventDetailsModalStyle.subTitleTypo} mt={1}>
              {dayjs(startEvent).format("MMMM DD, YYYY") +
                " at " +
                dayjs(startEvent).format("HH:mm")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12} md={12} mt={2}>
            <Typography {...EventDetailsModalStyle.mainTitleTypo}>
              {t("calendarModal.end")}
            </Typography>
            <Typography {...EventDetailsModalStyle.subTitleTypo} mt={1}>
              {dayjs(endEvent).format("MMMM DD, YYYY") +
                " at " +
                dayjs(endEvent).format("HH:mm")}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} lg={12} md={12} mt={2}>
            <Typography {...EventDetailsModalStyle.mainTitleTypo}>
              {t("calendarModal.aboutEvent")}
            </Typography>
            <Typography {...EventDetailsModalStyle.subTitleTypo} mt={1}>
              {eventData?.aboutEvent}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Stack {...EventDetailsModalStyle.modalBtnStack}>
        <ButtonComponent
          text={t("btnText.close")}
          variant="outlined"
          onClick={handleClose}
          sx={{
            ...EventDetailsModalStyle.modalBtnCancelSx,
          }}
        />
      </Stack>
    </>
  );
};

export default EventDetailsModal;
